var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOneSpace = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 25,
  fill: "none",
  viewBox: "0 0 25 25"
}, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "one-space_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.616.183h24v24h-24z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#one-space_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 10.239,
  height: 16.5,
  x: 7.497,
  y: 3.933,
  stroke: "currentColor",
  strokeWidth: 1.5,
  rx: 1.25
}))));
export { SvgOneSpace as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjI1IiB2aWV3Qm94PSIwIDAgMjUgMjUiIHdpZHRoPSIyNSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGNsaXBQYXRoIGlkPSJhIj48cGF0aCBkPSJtLjYxNjIxMS4xODI2MTdoMjR2MjRoLTI0eiIvPjwvY2xpcFBhdGg+PGcgY2xpcC1wYXRoPSJ1cmwoI2EpIj48cmVjdCBoZWlnaHQ9IjE2LjUiIHJ4PSIxLjI1IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjUiIHdpZHRoPSIxMC4yMzkxIiB4PSI3LjQ5NjgzIiB5PSIzLjkzMjYyIi8+PC9nPjwvc3ZnPg==";